import createCache, { StylisPlugin } from '@emotion/cache';
import { prefixer } from 'stylis';
import stylisRTLPlugin from 'stylis-plugin-rtl';
import { TLocales } from '../type/locales';
import { Locales } from '../enum/locales';

const isBrowser = typeof document !== 'undefined';

// On the client side, Create a meta tag at the top of the <head> and set it as insertionPoint.
// This assures that MUI styles are loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.

export const createEmotionCache = (locale: TLocales | string) => {
  let insertionPoint;
  let stylisPlugins: StylisPlugin[] = [];
  if (locale === Locales.ar) {
    stylisPlugins = [prefixer, stylisRTLPlugin];
  }
  if (isBrowser) {
    const emotionInsertionPoint = document.querySelector<HTMLMetaElement>(
      'meta[name="emotion-insertion-point"]'
    );
    insertionPoint = emotionInsertionPoint ?? undefined;
  }

  return createCache({
    key: 'mui-style',
    prepend: true,
    stylisPlugins,
    insertionPoint,
  });
};
